export const VALID_BLOCK_TYPES = new Set([
  // Variables — unified type-driven pair (old typed kept below for compat)
  'set_variable', 'get_variable',
  // DEPRECATED legacy typed variable blocks — kept for old-xml validation only;
  // remove together with their defs + registrations (see blockly-interface.component.ts
  // DEPRECATED markers) once a corpus pass confirms no saved function uses them.
  // ➤ CORPUS PASS 2026-06-29 (docs/data/blockly-functions-2026-06-29): NOT removable — 10,032 saved
  //   instances of these typed scalar blocks vs 44 of the unified set_variable/get_variable. Removal
  //   condition NOT met; dual-representation is a deliberate, permanent decision
  //   (docs/plans/block-reduction-2026-06.md §"Dual-representation is permanent"). Do NOT remove.
  'set_number_variable', 'get_number_variable',
  'set_string_variable', 'get_string_variable',
  'set_boolean_variable', 'get_boolean_variable',
  'set_time_stamp_variable', 'get_time_stamp_variable',
  // Entity variables
  'set_entity_variable', 'get_entity_variable',
  'set_entity_list_variable', 'get_entity_list_variable',
  'get_entity_length',
  'set_entity_variable_by_index_of_entity_list',
  'push_new_element_to_array', 'push_to_entity_list',
  'delete_from_entity_list',
  // AOB reference
  'set_reference_entity_variable_for_AOB',
  'get_reference_entity_variable_for_AOB_reference_AOB',
  'set_key_value_in_AOB_reference',
  // AOB typed — unified type-driven pair (Phase 2)
  'set_aob_variable', 'get_aob_variable',
  // DEPRECATED legacy typed AOB blocks — kept for old-xml validation only; remove with
  // their defs/registrations once a corpus pass confirms no saved function uses them.
  // ➤ CORPUS PASS 2026-06-29: NOT removable — 1,593 saved instances of these typed AOB blocks vs 0
  //   of the unified set_aob_variable/get_aob_variable. Permanent dual-representation; do NOT remove.
  'set_reference_entity_variable_for_AOB_variable_string',
  'get_reference_entity_variable_for_AOB_variable_string',
  'set_reference_entity_variable_for_AOB_variable_number',
  'get_reference_entity_variable_for_AOB_variable_number',
  'set_reference_entity_variable_for_AOB_variable_boolean',
  'get_reference_entity_variable_for_AOB_variable_boolean',
  'set_reference_entity_variable_for_AOB_variable_time_stamp',
  'get_reference_entity_variable_for_AOB_variable_time_stamp',
  // Text
  'text', 'text_join', 'text_append', 'text_length', 'text_isEmpty',
  'text_indexOf', 'text_charAt', 'text_getSubstring',
  'text_changeCase', 'text_trim', 'text_prompt_ext',
  'string_regex_match', 'string_contains', 'polygon_area', 'reverse_geocode', 'point_count',
  'check_location_access', 'ask_location_access',
  'format_iso_date', 'parse_date_to_iso',
  // Logic
  'controls_if', 'logic_compare', 'logic_operation', 'logic_negate',
  'logic_boolean', 'logic_null', 'logic_ternary', 'value_is_empty',
  // Math
  'math_number', 'math_arithmetic', 'math_single', 'math_trig',
  'math_constant', 'math_number_property', 'math_round',
  'math_on_list', 'math_modulo', 'math_constrain',
  'math_random_int', 'math_random_float',
  'trim_decimals', 'number_to_words',
  // Time Stamp
  'current_date_iso', 'date_add_days', 'date_start_of_month', 'date_end_of_month', 'date_start_of_day', 'date_end_of_day', 'time_difference', 'date_diff_hours', 'date_diff_minutes', 'set_date', 'set_time',
  // Loops — controls_for REMOVED 2026-07-09 (deprecated; superseded by custom_loop; already retired from
  // Forge). Blockly-core def stays, so the 2 legacy saves still load. Archived: docs/archive/stale-blocks/.
  'controls_repeat_ext', 'controls_whileUntil',
  'controls_forEach', 'controls_flow_statements', 'custom_loop',
  // Query
  'get_query', 'entity_aggregate_query', 'get_set_order_variable',
  // DEPRECATED 2026-06-26 (Phase 3.5): the typed condition blocks are hidden from the toolbox
  // (superseded by add_condition/condition_group/clear_conditions) but stay in VALID_BLOCK_TYPES
  // so old saved functions still load + decompile. Forge no longer generates them.
  // ➤ CORPUS PASS 2026-06-29: NOT removable — 560 saved instances of these typed condition blocks vs
  //   1 imperative add_condition. Permanent dual-representation; do NOT remove. (Whether Forge still
  //   *generates* the typed condition blocks is a separate Forge-generation question, tracked elsewhere.)
  'entity_conditions', 'entity_or_conditions', 'entity_and_conditions',
  'entity_set_string_in_conditions', 'entity_string_conditions',
  'entity_set_number_in_conditions', 'entity_number_conditions',
  'entity_set_boolean_in_conditions', 'entity_boolean_conditions',
  'entity_set_time_stamp_in_conditions', 'entity_time_stamp_conditions',
  'entity_set_id_in_conditions', 'entity_id_conditions',
  'entity_is_null_conditions',
  'update_entity', 'create_entity', 'entity_reference_selection',
  // AAOB — aaob_filter_by_label + aaob_label_exists + aaob_sort_by_label REMOVED 2026-07-09 (deprecated;
  // superseded by add_condition/add_order on AAOB fields). Defs kept registered in query-helper.ts so the
  // 4 aaob_sort_by_label saves (apollo_crm/apollo-v2 leadManagementPage) still load. Archived: docs/archive/stale-blocks/.
  'aaob_aggregate_by_label',
  // Imperative condition builder (Phase 3)
  'add_condition', 'condition_group', 'clear_conditions',
  // Imperative order (sort) builder (Phase 3)
  'add_order', 'clear_orders',
  // Async
  'async_function_wrapper', 'resolve_promise_by_group',
  // Special Functions
  'show_toast', 'set_navigation', 'show_loading_screen',
  'get_current_user', 'get_users_list', 'get_roles_list',
  'create_user', 'edit_user', 'get_email', 'logout_user',
  'person_remove', 'person_reinstate', 'person_erase', 'person_transfer', 'delete_record', 'user_delete_account',
  'meta_page_subscription',
  'open_external_string',
  // Function-entity blocks + set_variable_entity REMOVED 2026-07-09 (dead / 0 saved uses; superseded).
  // Archived: docs/archive/stale-blocks/. Do NOT re-add. (push_to_entity_list is KEPT above — 227 saved uses.)
  // Conditional
  'return_boolean',
  // Value functions (input bindings)
  'return_value',
  // lists_create_with REMOVED 2026-07-09 (0 saved uses; pulled from toolbox + Forge). Archived: docs/archive/stale-blocks/.
  // Wrapper
  'procedures_defnoreturn',
]);

export function isDynamicBlockType(type: string): boolean {
  return type.endsWith('_api_functions') || type.endsWith('_ap_workflow');
}

export function isValidBlockType(type: string): boolean {
  return VALID_BLOCK_TYPES.has(type) || isDynamicBlockType(type);
}

export const SETTER_BLOCK_FOR_TYPE: Record<string, string> = {
  // scalar types now route to the unified type-driven block
  'String': 'set_variable',
  'Number': 'set_variable',
  'Boolean': 'set_variable',
  'TimeStamp': 'set_variable',
  'GEOMETRY': 'set_variable',
  'ENTITY_VARIABLE': 'set_entity_variable',
  'ENTITY_LIST_VARIABLE': 'set_entity_list_variable',
};

export const GETTER_BLOCK_FOR_TYPE: Record<string, string> = {
  'String': 'get_variable',
  'Number': 'get_variable',
  'Boolean': 'get_variable',
  'TimeStamp': 'get_variable',
  'GEOMETRY': 'get_variable',
  'ENTITY_VARIABLE': 'get_entity_variable',
  'ENTITY_LIST_VARIABLE': 'get_entity_list_variable',
};

export const CONDITION_SETTER_FOR_TYPE: Record<string, string> = {
  'String': 'entity_set_string_in_conditions',
  'Number': 'entity_set_number_in_conditions',
  'Boolean': 'entity_set_boolean_in_conditions',
  'TimeStamp': 'entity_set_time_stamp_in_conditions',
  'ID': 'entity_set_id_in_conditions',
};

export const CONDITION_BLOCK_FOR_TYPE: Record<string, string> = {
  'String': 'entity_string_conditions',
  'Number': 'entity_number_conditions',
  'Boolean': 'entity_boolean_conditions',
  'TimeStamp': 'entity_time_stamp_conditions',
  'ID': 'entity_id_conditions',
};

export const AOB_SETTER_FOR_TYPE: Record<string, string> = {
  // all scalar types now route to the unified type-driven AOB block
  'String': 'set_aob_variable',
  'Number': 'set_aob_variable',
  'Boolean': 'set_aob_variable',
  'TimeStamp': 'set_aob_variable',
  'GEOMETRY': 'set_aob_variable',
};

export const AOB_GETTER_FOR_TYPE: Record<string, string> = {
  'String': 'get_aob_variable',
  'Number': 'get_aob_variable',
  'Boolean': 'get_aob_variable',
  'TimeStamp': 'get_aob_variable',
  'GEOMETRY': 'get_aob_variable',
};

export const BLOCK_CATALOG = `
## Block Catalog

**System-variable rule (enforced):** any variable or field whose name contains "system" is READ-ONLY for
persistence — read it freely in get_* blocks. The id / id_auto_increment / parent_id fields are never
selectable at all. The entity setters (set_entity_variable, set_entity_list_variable, set_aob_variable) MAY
carry a system-word field, but create_entity / update_entity strip every system-word field from the write
payload at runtime — so it never persists (a harmless no-op); don't rely on writing them. Every OTHER set_*
target (set_variable, push, the legacy typed setters) still REFUSES a system-word VAR: the compiler drops it
and the block becomes a no-op. So a fetched entity's system values are never written back either way.

### Variables (set/get typed variables)

| Block | Type | Fields | Inputs | Connection |
|-------|------|--------|--------|------------|
| set_variable | stmt | VAR: variable ID | VALUE: (check follows the variable's type) | prev/next |
| get_variable | value→(the variable's type) | VAR: variable ID | — | output |

VAR field uses the encoded variable ID (e.g. "localVariable$myVar" or "globalVariable$myVar").

### Entity Variables

| Block | Type | Fields | Inputs | Connection |
|-------|------|--------|--------|------------|
| set_entity_variable | stmt | VAR: entity var ID | VALUE: ENTITY | prev/next |
| get_entity_variable | value→ENTITY | VAR: entity var ID | — | output |
| set_entity_list_variable | stmt | VAR: entity list var ID | VALUE: ENTITY_LIST | prev/next |
| get_entity_list_variable | value→Array | VAR: entity list var ID | — | output |
| get_entity_length | value→Number | VAR: entity list var ID | — | output |
| push_new_element_to_array | stmt | (NO VAR field) | ARRAY_INPUT: {Array, REFERENCE_ENTITY_VARIABLE_AOB} — the target list, via a get_entity_list_variable child · optional INDEX_INPUT: Number · 0..N dynamic FIELD_&lt;key&gt;: scalar (the new row's values) | prev/next |
| push_to_entity_list | stmt | VAR: entity list var ID | VALUE: ENTITY | prev/next |
| delete_from_entity_list | stmt | VAR: entity list var ID | INDEX: Number | prev/next |
| set_entity_variable_by_index_of_entity_list | value→ENTITY | (NO VAR field) | VALUE: Array (entity list) · INDEX: Number | output (NO prev/next) |

### Entity Variable — AOB (Array of Object) Reference

**AAOB rule (see docs/blockly/aaob-model.md):** an AAOB is an AOB with extendedAttributes===true = runtime
user-added columns (systemKey/value). It may be touched ONLY via set_key_value_in_AOB_reference (write) +
aaob_aggregate_by_label (read); every other block here EXCLUDES AAOB entities/fields from its picker.

**Live unified AOB blocks (what Forge should emit — the typed *_variable_string/number/... rows below are DEPRECATED/dual-registered):**

| Block | Type | Fields | Inputs | Connection |
|-------|------|--------|--------|------------|
| set_aob_variable | stmt | VAR: AOB scalar-field ref (two-step: entity → scalar field) | VALUE: (check follows the field's scalar type) | prev/next |
| get_aob_variable | value→(the field's scalar type) | VAR: AOB scalar-field ref | — | output |
| set_reference_entity_variable_for_AOB | stmt | VAR: ref entity var ID | VALUE: {ENTITY, REFERENCE_ENTITY_VARIABLE_AOB} | prev/next |
| get_reference_entity_variable_for_AOB_reference_AOB | value→REFERENCE_ENTITY_VARIABLE_AOB | VAR: ref entity var ID | VALUE: Number (index) | output |
| set_key_value_in_AOB_reference | stmt | VAR: Database entity id OR local_variable%/global_variable% var that owns an AAOB · AAOB_FIELD: the AAOB (extendedAttributes) field · TYPE: dropdown (String only for now) | KEY: String · VALUE: String (TYPE-locked, not "varies") | prev/next |
| set_reference_entity_variable_for_AOB_variable_string | stmt | VAR: ref entity var ID | VALUE: String | prev/next |
| get_reference_entity_variable_for_AOB_variable_string | value→String | VAR: ref entity var ID | — | output |
| set_reference_entity_variable_for_AOB_variable_number | stmt | VAR: ref entity var ID | VALUE: Number | prev/next |
| get_reference_entity_variable_for_AOB_variable_number | value→Number | VAR: ref entity var ID | — | output |
| set_reference_entity_variable_for_AOB_variable_boolean | stmt | VAR: ref entity var ID | VALUE: Boolean | prev/next |
| get_reference_entity_variable_for_AOB_variable_boolean | value→Boolean | VAR: ref entity var ID | — | output |
| set_reference_entity_variable_for_AOB_variable_time_stamp | stmt | VAR: ref entity var ID | VALUE: TimeStamp | prev/next |
| get_reference_entity_variable_for_AOB_variable_time_stamp | value→TimeStamp | VAR: ref entity var ID | — | output |

### Text

| Block | Type | Fields | Inputs | Connection |
|-------|------|--------|--------|------------|
| text | value→String | TEXT: string literal | — | output |
| text_join | value→String | — | ADD0, ADD1, ... (mutator: itemCount_) | output |
| text_append | stmt | VAR: variable ID | TEXT: String | prev/next |
| text_length | value→Number | — | VALUE: String | output |
| text_isEmpty | value→Boolean | — | VALUE: String | output |
| text_indexOf | value→Number | END: FIRST/LAST | VALUE: String, FIND: String | output |
| text_charAt | value→String | WHERE: FROM_START/FROM_END/FIRST/LAST/RANDOM | VALUE: String, AT: Number | output |
| text_getSubstring | value→String | WHERE1, WHERE2 | STRING: String, AT1: Number, AT2: Number | output |
| text_changeCase | value→String | CASE: UPPERCASE/LOWERCASE/TITLECASE | TEXT: String | output |
| text_trim | value→String | MODE: BOTH/LEFT/RIGHT | TEXT: String | output |
| string_regex_match | value→Boolean | — | TEXT: String, PATTERN: String | output |
| string_contains | value→Boolean | — | TEXT: String, SUBSTRING: String | output |
| polygon_area | value→Number | UNIT: hectares/acres/sqm/sqkm | GEOMETRY: GEOMETRY\|String | output |
| reverse_geocode | value→String | — | GEOMETRY: GEOMETRY\|String | output (async) |
| point_count | value→Number | — | GEOMETRY: GEOMETRY\|String | output |
| check_location_access | stmt (multi-out) | — | allowed/canBeAsked/refusedForGood/switchedOff: Boolean (each optional; assigns into a connected getter) | prev/next |
| ask_location_access | stmt | — | — | prev/next |
| format_iso_date | value→String | ZONE: project\|utc (default project — prints the project's clock) | DATE: TimeStamp | output |
| parse_date_to_iso | value→TimeStamp | ZONE: project\|utc (default project — the text is read as project time) | DATE_STR: String | output |

### Logic

| Block | Type | Fields | Inputs | Connection |
|-------|------|--------|--------|------------|
| controls_if | stmt | — (mutator: elseifCount_, elseCount_) | IF0, IF1...: Boolean; DO0, DO1...: stmts; ELSE: stmts | prev/next |
| logic_compare | value→Boolean | OP: EQ/NEQ/LT/LTE/GT/GTE | A, B | output |
| logic_operation | value→Boolean | OP: AND/OR | A, B | output |
| logic_negate | value→Boolean | — | BOOL: Boolean | output |
| logic_boolean | value→Boolean | BOOL: TRUE/FALSE | — | output |
| logic_null | value→null | — | — | output |
| value_is_empty | value→Boolean | — | VALUE: any | output |
| logic_ternary | value→varies | — | IF: Boolean, THEN, ELSE | output |

### Math

| Block | Type | Fields | Inputs | Connection |
|-------|------|--------|--------|------------|
| math_number | value→Number | NUM: number literal | — | output |
| math_arithmetic | value→Number | OP: ADD/MINUS/MULTIPLY/DIVIDE/POWER | A: Number, B: Number | output |
| math_single | value→Number | OP: ROOT/ABS/NEG/LN/LOG10/EXP/POW10 | NUM: Number | output |
| math_trig | value→Number | OP: SIN/COS/TAN/ASIN/ACOS/ATAN | NUM: Number | output |
| math_constant | value→Number | CONSTANT: PI/E/GOLDEN_RATIO/SQRT2/SQRT1_2/INFINITY | — | output |
| math_number_property | value→Boolean | PROPERTY: EVEN/ODD/PRIME/WHOLE/POSITIVE/NEGATIVE/DIVISIBLE_BY | NUMBER_TO_CHECK: Number | output |
| math_round | value→Number | OP: ROUND/ROUNDUP/ROUNDDOWN | NUM: Number | output |
| math_on_list | value→Number | OP: SUM/MIN/MAX/AVERAGE/MEDIAN/MODE/STD_DEV/RANDOM | LIST | output |
| math_modulo | value→Number | — | DIVIDEND: Number, DIVISOR: Number | output |
| math_constrain | value→Number | — | VALUE: Number, LOW: Number, HIGH: Number | output |
| math_random_int | value→Number | — | FROM: Number, TO: Number | output |
| math_random_float | value→Number | — | — | output |
| trim_decimals | value→Number | — | NUMBER: Number, DECIMALS: Number | output |
| number_to_words | value→String | — | NUMBER: Number | output |

### Time Stamp

| Block | Type | Inputs | Output |
|-------|------|--------|--------|
| current_date_iso | value→TimeStamp | — | TimeStamp |
| date_add_days | value→TimeStamp | DATE: TimeStamp, DAYS: Number, UNIT: day\|month\|year\|hour\|minute, ZONE: project\|utc (default project — days/months step on the project's calendar) | TimeStamp |
| set_date | value→TimeStamp | DAY/MONTH/YEAR: Number literals (inline fields) → the fn is build_date(day,month,year); midnight at the start of that day in the project's time zone; ZONE: project\|utc (default project) | TimeStamp |
| set_time | value→TimeStamp | DATE: TimeStamp, HOUR/MINUTE: Number literals (inline fields) → the fn is set_time_of_day(date,hour,minute); seconds zeroed, on the date's own day in the project's time zone; ZONE: project\|utc (default project) | TimeStamp |
| date_start_of_month | value→TimeStamp | DATE: TimeStamp, ZONE: project\|utc (default project) | TimeStamp (first day of that month, 00:00 in the project's time zone) |
| date_end_of_month | value→TimeStamp | DATE: TimeStamp, ZONE: project\|utc (default project) | TimeStamp (last day of that month, 23:59:59.999 in the project's time zone) |
| date_start_of_day | value→TimeStamp | DATE: TimeStamp, ZONE: project\|utc (default project) | TimeStamp (that day at 00:00 in the project's time zone) |
| date_end_of_day | value→TimeStamp | DATE: TimeStamp, ZONE: project\|utc (default project) | TimeStamp (that day at 23:59:59.999 in the project's time zone — the "to" end of a date range) |
| date_diff_hours | value→Number | DATE_A: TimeStamp, DATE_B: TimeStamp | Number |
| date_diff_minutes | value→Number | DATE_A: TimeStamp, DATE_B: TimeStamp | Number |
| time_difference | statement (multi-out) | dateA/dateB: TimeStamp, UNIT: year\|month\|week\|day\|hour\|minute, ZONE: project\|utc (default project — months and years counted on the project's calendar); writes isPositive: Boolean, whole: Number, remainder: Number | — (assigns 3 vars) |

### Loops

| Block | Type | Fields | Inputs | Connection |
|-------|------|--------|--------|------------|
| controls_repeat_ext | stmt | — | TIMES: Number; DO: stmts | prev/next |
| controls_whileUntil | stmt | MODE: WHILE/UNTIL | BOOL: Boolean; DO: stmts | prev/next |
<!-- DEPRECATED 2026-06-29: controls_for retired from Forge generation — superseded by custom_loop
     (corpus 2026-06-29 shows only 2 legacy saved uses). Kept in VALID_BLOCK_TYPES so those still
     load/validate; do NOT re-add this row — Forge should emit custom_loop instead.
| controls_for | stmt | VAR: loop var | FROM: Number, TO: Number, BY: Number; DO: stmts | prev/next | -->
| controls_forEach | stmt | VAR: loop var | LIST; DO: stmts | prev/next |
| controls_flow_statements | stmt | FLOW: BREAK/CONTINUE | — | prev |
| custom_loop | stmt | — | DO: stmts | prev/next |

### Query

| Block | Type | Fields | Inputs | Connection |
|-------|------|--------|--------|------------|
| get_query | value→ENTITY_LIST | VAR: entity **id** | C: Number (limit), D: Number (offset) — (B/CONDITIONS/EC/E REMOVED post-Phase-3.5; WHERE/ORDER now come from preceding imperative add_condition/add_order sibling blocks, not value sockets) | output |
| get_set_order_variable | value→ORDER | VAR: field ID, DROPDOWN: asc/desc | — | output |
| entity_conditions | value→ENTITYCONDITIONS | VAR: entity name | B: ORDER, C: Number, D: Number, CONDITIONS, E: ENTITY_SIBLING | output |
| entity_or_conditions | value→OR | — | CHILD_CONDITIONS, SIBILING_CONDITIONS | output |
| entity_set_string_in_conditions | value→QUERY_VARIABLE | VAR: field ID | SET: STRINGCONDITIONS, SIBILING_CONDITIONS | output |
| entity_string_conditions | value→STRINGCONDITIONS | DROPDOWN: operator | SET: String, SIBILING_CONDITIONS | output |
| entity_set_number_in_conditions | value→QUERY_VARIABLE | VAR: field ID | SET: NUMBERCONDITIONS, SIBILING_CONDITIONS | output |
| entity_number_conditions | value→NUMBERCONDITIONS | DROPDOWN: operator | SET: Number, SIBILING_CONDITIONS | output |
| entity_set_boolean_in_conditions | value→QUERY_VARIABLE | VAR: field ID | SET: BOOLEANCONDITIONS, SIBILING_CONDITIONS | output |
| entity_boolean_conditions | value→BOOLEANCONDITIONS | DROPDOWN: operator | SET: Boolean, SIBILING_CONDITIONS | output |
| entity_set_time_stamp_in_conditions | value→QUERY_VARIABLE | VAR: field ID | SET: TIMESTAMPCONDITIONS, SIBILING_CONDITIONS | output |
| entity_time_stamp_conditions | value→TIMESTAMPCONDITIONS | DROPDOWN: operator | SET: TimeStamp, SIBILING_CONDITIONS | output |
| entity_set_id_in_conditions | value→QUERY_VARIABLE | VAR: field ID | SET: ENTITYREFERENCECONDITIONS, SIBILING_CONDITIONS | output |
| entity_id_conditions | value→ENTITYREFERENCECONDITIONS | DROPDOWN: operator | SET: ENTITY, SIBILING_CONDITIONS | output |
| entity_is_null_conditions | value→GLOBALCONDITIONS | DROPDOWN: True/False | — | output |
| entity_and_conditions | value | — | (children) | output |
| update_entity | stmt | (NO VAR) | VALUE: ENTITY (the entity to update — a get_entity_variable) · ENTITY_REFERENCE_SELECTION: ENTITY_REFERENCE_SELECTION | prev/next |
| create_entity | stmt | VAR: entity **type** to create (ENTITYNAME) | VALUE: ENTITY_REFERENCE_SELECTION · ENTITY: ENTITY (destination — where the created entity is assigned) · FLAG: Boolean | prev/next |
| entity_reference_selection | value→ENTITY_REFERENCE_SELECTION | VAR: ref field ID, CONSIDER_ENTITY: checkbox | ENTITY: ENTITY, NEXT: ENTITY_REFERENCE_SELECTION | output |

### AAOB Query Blocks

| Block | Type | Fields | Inputs | Connection |
|-------|------|--------|--------|------------|
| entity_aggregate_query | value→Number | VAR: entity **id**, OP: avg/sum/min/max/count, COLUMN: field | (NO value inputs — CONDITIONS/EC removed; WHERE comes from the imperative condition buffer) | output |
| aaob_aggregate_by_label | value→Number | VAR: entity name, AAOB_FIELD: field, OP: avg/sum/min/max/count | KEY: String, CONDITIONS, EC | output |

### Async

| Block | Type | Fields | Inputs | Connection |
|-------|------|--------|--------|------------|
| async_function_wrapper | stmt | ASYNC_GROUP: A-K | TRY: statements, CATCH: statements, FINALLY: statements | prev/next |
| resolve_promise_by_group | stmt | ASYNC_GROUP: A-K | BODY: statements | prev/next |

### Special Functions

| Block | Type | Fields | Inputs | Connection |
|-------|------|--------|--------|------------|
| show_toast | stmt | — | message: String, type: dropdown (success/error/warning/info), duration: Number | prev/next |
| set_navigation | stmt | — | url: String | prev/next |
| show_loading_screen | stmt | — | showLoading: Boolean | prev/next |
| get_current_user | stmt | — | user: ENTITY — **DESTINATION** (fetched value assigned INTO the child; binds systemOotbUser) | prev/next |
| get_users_list | stmt | — | users: Array — **DESTINATION** (binds systemOotbUser) | prev/next |
| get_roles_list | stmt | — | roles: Array — **DESTINATION** (binds synthetic role_global, no PG table) | prev/next |
| create_user | stmt | — | (NO inputs — hardcodes user_global; retired from toolbox, still registered) | prev/next |
| edit_user | stmt | — | user: ENTITY — **SOURCE** (child is READ: userService.edit(user.data), NOT written; retired from toolbox) | prev/next |
| get_email | value→String | — | — | output |
| logout_user | stmt | — | — | prev/next |
| open_external_string | stmt | — | URL: String | prev/next — label "open link". tel:/mailto:/sms: open the phone's app in place, anything else a new tab; a bare email → mailto:, a bare web address → https://; a bare phone number is NOT completed (needs "tel:" + number) |

### Dynamic Blocks (generated per-page)

**API Functions:** \`{functionName}_api_functions\` — one block per registered function. Inputs match function signature.
**AP Workflows:** \`{flowSlug}_ap_workflow\` — one block per connected workflow. Inputs match workflow signature.

These blocks are created at runtime from \`functionList\` and \`cachedApFlows\`. Their inputs/outputs vary.

### Conditional Functions

| Block | Type | Inputs | Connection |
|-------|------|--------|------------|
| return_boolean | stmt | VALUE: Boolean | prev/next |

### Wrapper

| Block | Type | Fields | Inputs | Connection |
|-------|------|--------|--------|------------|
| procedures_defnoreturn | stmt | NAME: function name | STACK: stmts | — |

procedures_defnoreturn is the function definition wrapper. Forge does not generate this block — it is created automatically when a function is loaded.

### Mutation Blocks

These blocks require mutation before extra inputs exist:
- **controls_if**: Set \`elseifCount_\` and \`elseCount_\`, call \`updateShape_()\` to add IF1/DO1+, ELSE.
- **text_join**: Set \`itemCount_\`, call \`updateShape_()\` to add ADD0, ADD1, ADD2... inputs.
`;
